<template>
  <div>
    <section class="section section-container ">
      <div class="container px-0">
        <div class="row justify-content-center text-center">
          <h2 class="display-3 mt-5">Standard Fence Design</h2>
        </div>
      </div>
    </section>

    <div class="px-0 mt-4" v-for="(product, index) in products" :key="index">
      <div class="odd" v-if="index % 2 !== 0">
        <ProductRight :product="product" :key="index" />
      </div>
      <div class="even" v-else>
        <ProductLeft :product="product" :key="index" />
      </div>
    </div>

  </div>
</template>

<script>
import productDAO from "../database/products";
import ProductRight from "./components/products/ProductRight";
import ProductLeft from "./components/products/ProductLeft";
import _ from 'lodash';

export default {
  name: "pre-cast-fence",
  components: {
    ProductLeft,
    ProductRight,
  },
  data() {
    return {
      products: [],
      addedProducts: [],
    };
  },
  created() {
    this.retrieveAll();
  },
  methods: {
    async retrieveAll() {
      try {
        this.products = await productDAO.retrieveActive(false);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

  .section-container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .on-sm-text-left {
    text-align: left !important;
  }

  .on-sm-text-center {
    text-align: center !important;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .hero {
    height: 500px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .hero {
    height: 500px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .hero {
    height: 500px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .hero {
    height: 500px;
  }
}
</style>
